import { http } from '@/core/helpers/http.helper';
import { CANDIDATE_INCLUDES } from '../candidates/candidate.service';
import { ApiResource } from './../../models/api-resource.interface';
import { CallList, CallListImport, CallListSearchResponse } from './call-list.interface';

export class CallListService {
   async getCallLists() {
      const response = await http.get<ApiResource<Array<CallList>>>(`/call-lists?include=user`, { params: { per_page: 9999 } });

      return response.data;
   }

   async searchCallList(body: CallListImport) {
      const response = await http.post<CallListSearchResponse>(`/call-lists/search`, body, {
         params: { include: CANDIDATE_INCLUDES.all.includes.join(), append: CANDIDATE_INCLUDES.all.appends.join(), per_page: 1000 },
      });
      return response.data;
   }

   async getCallList() {
      throw Error('Method not implemented');
   }

   async postCallList(callList: CallList) {
      const response = await http.post<ApiResource<CallList>>(`/call-lists`, callList);
      return response.data;
   }

   async putCallList(callList: CallList) {
      const response = await http.put<ApiResource<CallList>>(`/call-lists/${callList.id}`, callList);
      return response.data;
   }

   async deleteCallList(callListId: number) {
      const response = await http.delete<ApiResource<CallList>>(`/call-lists/${callListId}`);
      return response.data;
   }
}
